import { render, staticRenderFns } from "./gebruiker-aanmaken.html?vue&type=template&id=5e1ee6c0&scoped=true&"
import script from "./gebruiker-aanmaken.js?vue&type=script&lang=js&"
export * from "./gebruiker-aanmaken.js?vue&type=script&lang=js&"
import style0 from "./gebruiker-aanmaken.css?vue&type=style&index=0&id=5e1ee6c0&scoped=true&lang=css&"
import style1 from "@/css/appschoolware.css?vue&type=style&index=1&id=5e1ee6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1ee6c0",
  null
  
)

export default component.exports